// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3noUY","col":"Table_col__Vbn5T","fulfillmentStatus":"Table_fulfillmentStatus__33n21","emailCol":"Table_emailCol__2pcc5"};